
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkMailTemplateInformation } from '../models/work-mail-template-information';
import { WorkAttachementUrl } from '../models/work-attachement-url';

export function getSendMailFromTemplateDtoFormGroup() {
return new FormGroup({
    onlyCreateDraft: new FormControl<any | undefined>(undefined, [Validators.required]),
    senderUserId: new FormControl<number | undefined>(undefined),
    targetContactId: new FormControl<number | undefined>(undefined),
    targetUserId: new FormControl<number | undefined>(undefined),
    targetEmail: new FormControl<string | undefined>(''),
    template: new FormControl<WorkMailTemplateInformation | undefined>(undefined),
    attachementUrls: new FormControl<WorkAttachementUrl[]>([]),
    secret: new FormControl<string | undefined>(''),
})
;
}
      